import {
  MOTION_DISTANCE,
  MOTION_DURATION,
  MOTION_MOBILE_BREAKPOINT,
  MOTION_STAGGER,
} from './constants';

export type MotionScale = {
  isMobile: boolean;
  distance: number;
  blockDistance: number;
  stagger: number;
  duration: typeof MOTION_DURATION;
};

/**
 * Returns reduced motion intensity for smaller viewports.
 * Prefer CSS vars via applyMotionVars so styles stay declarative.
 */
export const getMotionScale = (width?: number): MotionScale => {
  const viewport =
    typeof width === 'number'
      ? width
      : typeof window !== 'undefined'
        ? window.innerWidth
        : MOTION_MOBILE_BREAKPOINT + 1;

  const isMobile = viewport <= MOTION_MOBILE_BREAKPOINT;

  return {
    isMobile,
    distance: isMobile ? MOTION_DISTANCE.mobile : MOTION_DISTANCE.desktop,
    blockDistance: isMobile ? MOTION_DISTANCE.blockMobile : MOTION_DISTANCE.block,
    stagger: isMobile ? MOTION_STAGGER.mobile : MOTION_STAGGER.desktop,
    duration: MOTION_DURATION,
  };
};

/** Writes reusable CSS custom properties consumed by animation styles. */
export const applyMotionVars = (
  element: HTMLElement | null,
  scale: MotionScale = getMotionScale()
): void => {
  if (!element) return;

  element.style.setProperty('--motion-distance', `${scale.distance}px`);
  element.style.setProperty('--motion-block-distance', `${scale.blockDistance}px`);
  element.style.setProperty('--motion-stagger', `${scale.stagger}ms`);
  element.style.setProperty('--motion-duration-fade', `${scale.duration.fadeUp}ms`);
  element.style.setProperty('--motion-duration-zoom', `${scale.duration.zoomOut}ms`);
  element.style.setProperty('--motion-duration-image', `${scale.duration.imageReveal}ms`);
  element.style.setProperty('--motion-duration-mask', `${scale.duration.maskReveal}ms`);
  element.style.setProperty('--motion-duration-text', `${scale.duration.textFade}ms`);
};
